import {
  useDeepSignalFromLocalStorage,
  useLocalDeepStorageKeyValue,
  useSignalWithLocalStorage,
} from '@util/deepSignals.js';
import useTiltifyConfig from '@hooks/useTiltifyConfig.js';
import useTwitchConfig from '@hooks/useTwitchConfig.js';
import { useContext } from 'preact/hooks';
import { ProductContext } from '../context/productContext.js';
import { buildCustomizedURL } from '@util/common.js';
import { CHARITY } from '@util/const.js';

export default function useCommon({config, urlBase, urlSuffix, urlSimplified = false, addTiltifyCampaign = true, addCharityType = true, forceTiltify = false}) {
  useDeepSignalFromLocalStorage(config);
  const setConfigState = useSignalWithLocalStorage(config);
  const setConfigKeyValue = useLocalDeepStorageKeyValue(config);
  const tiltifyConfig = useTiltifyConfig();
  const twitchConfig = useTwitchConfig();
  const overlayInfo = useContext(ProductContext);
  const overlayURL = buildCustomizedURL({
    config: forceTiltify ? {
      ...config,
      ...twitchConfig,
      ...tiltifyConfig,
      charityType: CHARITY.TILTIFY,
    } : {
      ...config,
      ...twitchConfig,
      ...tiltifyConfig,
    },
    urlBase: urlBase ? urlBase : overlayInfo.type,
    addCharityType,
    urlSuffix,
    urlSimplified,
    addTiltifyCampaign,
  });

  const overlayDemoURL = buildCustomizedURL({
    config: {
      ...config,
      ...twitchConfig,
      ...tiltifyConfig,
      charityType: CHARITY.TILTIFY,
      demoMode: 'yes',
    },
    urlBase: urlBase ? urlBase : overlayInfo.type,
    addCharityType,
    urlSuffix,
  });

  return {
    overlayURL,
    overlayDemoURL,
    overlayInfo,
    setConfigState,
    setConfigKeyValue,
    twitchConfig,
    tiltifyConfig,
  }
}